import {QueryParams} from "../shared/enums/queryParams";
import {RoutePaths} from "../shared/routePaths";

export const getEventsUrl = (
  eventId: string,
  villageIdQueryParam: string,
  selectedCalendarName: string,
  tabName?: string,
  occurrenceDate?: Date | null,
  editingSeries?: boolean
): string => {
  let defaultUrl = `${RoutePaths.Events}/events/${eventId}?${villageIdQueryParam}&${QueryParams.calendar}=${selectedCalendarName}`;

  if (tabName) {
    defaultUrl += `&${QueryParams.Tab}=${tabName}`;
  }

  if (occurrenceDate) {
    const dateFormat = encodeURIComponent(occurrenceDate.toISOString());
    defaultUrl += `&${QueryParams.OccurrenceDate}=${dateFormat}`;
  }
  if (editingSeries) {
    defaultUrl += `&${QueryParams.EditSeries}=${editingSeries}`;
  }

  return defaultUrl;
};
